"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const QwilrGrayscale = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M12 23.5C18.3513 23.5 23.5 18.3513 23.5 12C23.5 5.64873 18.3513 0.5 12 0.5C5.64873 0.5 0.5 5.64873 0.5 12C0.5 18.3513 5.64873 23.5 12 23.5Z",
        fill: "white",
        stroke: "#8790A6"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        opacity: 0.5,
        d: "M6.48998 15.003L7.87998 17.121C7.93592 17.2039 8.01136 17.2718 8.09967 17.3188C8.18798 17.3657 8.28647 17.3903 8.38648 17.3903C8.4865 17.3903 8.58499 17.3657 8.6733 17.3188C8.76161 17.2718 8.83704 17.2039 8.89298 17.121L11.998 12.201L9.68998 8.535L6.46998 13.778C6.35589 13.9628 6.29714 14.1763 6.30069 14.3934C6.30423 14.6105 6.36992 14.8221 6.48998 15.003Z",
        fill: "#8790A6"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        opacity: 0.7,
        d: "M17.53 13.778L14.31 8.534L11.998 12.208L15.107 17.128C15.1628 17.2111 15.2382 17.2792 15.3265 17.3263C15.4148 17.3734 15.5134 17.3981 15.6135 17.3981C15.7136 17.3981 15.8122 17.3734 15.9005 17.3263C15.9888 17.2792 16.0642 17.2111 16.12 17.128L17.51 15.008C17.6297 14.826 17.6951 14.6137 17.6986 14.3959C17.7022 14.1781 17.6437 13.9638 17.53 13.778Z",
        fill: "#8790A6"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M13.427 7.09299L12.508 5.67499C12.4524 5.59124 12.3768 5.52256 12.2882 5.47505C12.1996 5.42754 12.1006 5.40268 12 5.40268C11.8995 5.40268 11.8005 5.42754 11.7118 5.47505C11.6232 5.52256 11.5477 5.59124 11.492 5.67499L10.573 7.09499L9.68903 8.53499L11.999 12.208L14.31 8.54999L13.426 7.09299H13.427Z",
        fill: "#8790A6"
      }
    )
  );
};
export default QwilrGrayscale;
